var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-check-double.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5957 9.1612L4.7577 11.5745L9.83504 5.77186L8.83104 4.89453L4.57504 9.75853L2.4037 8.1012L1.5957 9.1612ZM14.5017 5.77186L13.4977 4.89453L9.2517 9.7472L8.7497 9.34586L7.91637 10.3872L9.41437 11.5859L14.5017 5.77186Z",
    fill: "#365EFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.e6bd3da2cb29ac0424df16b9f344024d.svg";
export { ForwardRef as ReactComponent };